/* eslint-disable no-mixed-spaces-and-tabs */

import {
  Box,
	CircularProgress,
	FormHelperText,
	Select as MUISelect,
	styled
} from '@mui/material';
import Typography from '../typography/typography';
import SelectSearch from './select-search';
import { memo, useRef } from 'react';
import './controller/controller-select.scss'
import { ArrowDown } from '../icons';
const StyledSelect = styled(MUISelect)(({ theme: { palette } }) => ({
	color: palette.theme?.secondary[800],
	fontSize: ' 0.875rem',
	'.MuiOutlinedInput-notchedOutline': {
		borderColor: palette.theme?.secondary[300]
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderWidth: '0.0625rem',
		borderColor: palette.theme?.primary[700]
	},
	'&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
		borderWidth: '0.0625rem',
		borderColor: palette.theme?.error[600]
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: palette.theme?.secondary[400]
	},
	'&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: palette.theme?.error[600]
	},
	'&.Mui-disabled': {
		background: palette.theme?.secondary[200],
		color: palette.theme?.secondary[800]
	},

	'.MuiMenuItem-root': {
		fontSize: '10px'
	},
	'&.Mui-error': {
		color: palette.theme?.error[600],
		'&fieldset': {
			borderColor: 'grey'
		}
	}
}));

const Select = memo((props: any) => {
	const searchInputRef = useRef<HTMLInputElement>(null);
	const {
		children,
		label,
		handleSearch,
		dataPosition,
		dataName,
		placeholder,
		searchPlaceholder,
		required,
		searchValue,
		fullWidth = false,
		onChange,
		renderValue,
		error,
		helperText,
		loading = false,
		CustomDropdownIcon = ArrowDown,
		...rest
	} = props;

	
	const handleOpen = () => {
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus(); // Focus the search input
      }
    }, 0);
  };


	return (
		<>
			{label && (
				<Typography
					type='s5'
					weight='medium'
					data-position={dataPosition}
					data-name={dataName}
					mb={0.5}
					color={error ? 'theme.error.600' : 'theme.secondary.800'}>
					{label} {required && <span style={{ color: '#c64d4d' }}>*</span>}
				</Typography>
			)}
<StyledSelect
 IconComponent={(iconProps) => <CustomDropdownIcon {...iconProps} fontSize='small' />}
  MenuProps={{
    PaperProps: {
      sx: {
        maxHeight: 300, // Scrollable area for dropdown
        overflowY: 'auto',
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  }}
  displayEmpty
  fullWidth={fullWidth}
  renderValue={
    renderValue ??
    ((value: any) =>
      value !== '' ? (
        (value as any)
      ) : (
        <Typography color='inherit' type='s3'>
          {placeholder}
        </Typography>
      ))
  }
  onChange={onChange}
  error={error}
	onOpen={handleOpen} 
  {...rest}
>
  {handleSearch && (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1, // Ensure it's above the dropdown items
        backgroundColor: '#fff',
        // padding: '0.5rem',
				margin: '-4px -4px 0 -4px',
				mb: 0.5
      }}
    >
      <SelectSearch
				ref={searchInputRef}
        searchPlaceholder={searchPlaceholder}
        handleSearch={(e: any) => handleSearch(e.target.value)}
        value={searchValue}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
					e.stopPropagation();
					if (props?.value) {
						setTimeout(() => searchInputRef.current?.focus(), 0); 
					}
		  	}}
				sx={{
					p: 1,
				}}
      />
    </Box>
  )}
  {loading ? (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        p: 2,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={30} color='inherit' />
    </Box>
  ) : (
    children
  )}
</StyledSelect>

			{helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
		</>
	);
});

export { Select };
export default Select;
